import { BaseApiService } from '@/_services/baseApi.service'

export class StudentDataService extends BaseApiService {
  constructor () {
    super()
  }

  getStudentSchedule (date, studentId) {
    const url = `${process.env.VUE_APP_BASE_URL}/v1/student/${studentId}/schedule/date/${date}`
    return this.sendRequest('GET', url)
  }

  getGradeMark (studentId, yearId) {
    const url = `${process.env.VUE_APP_BASE_URL}/v1/quarter/grade/student/${studentId}/chronicle/${yearId}`
    return this.sendGetRequest(url)
  }
}

export default new StudentDataService()
